import { connectVoiceSearch } from 'react-instantsearch-core';
import VoiceSearch from "../components/VoiceSearch.js";
export default connectVoiceSearch(VoiceSearch, {
  $$widgetType: 'ais.voiceSearch'
});